import React from 'react';

/** Navigation only. The destination still enforces recovery eligibility. */
export function StoreSignatureStatusLinks({ cycleId, storeId, retailerId, operators, missingOperatorIds = [] }: {
  cycleId: string | null;
  storeId: number;
  retailerId: string | null;
  operators: Array<{ id: number; name: string }>;
  missingOperatorIds?: number[];
}) {
  if (!cycleId || !operators.length) return null;
  return <div className="flex flex-col gap-1">
    {operators.map(operator => {
      const params = new URLSearchParams({ cycleId, storeId: String(storeId), assignedOperatorId: String(operator.id) });
      if (retailerId) params.set('retailerId', retailerId);
      return <a key={operator.id}
        className="text-xs text-blue-700 underline rounded px-1 py-2 focus-visible:outline focus-visible:outline-2"
        href={`/admin/activation-cockpit/recovery/store?${params.toString()}`}
        onClick={event => event.stopPropagation()}
        onKeyDown={event => event.stopPropagation()}
        title="View received-signature and finalisation status; this does not complete or approve work">
        {missingOperatorIds.includes(operator.id) ? 'Manager sign-off missing' : 'Signature status'}{operators.length > 1 ? ` — ${operator.name}` : ''}
      </a>;
    })}
  </div>;
}
